import React, { useContext } from 'react';
import { getRuleLen, requiredRule } from '../../../../utils/rules';
import { OrgInfos } from '../../_utils/config';
import { Form } from '@roo/roo';

const { Field } = Form;

export function FieldX(props) {
  const { name, orgType } = props;
  const keys = name.split('.').filter(Boolean);
  const key = keys.pop();

  const target = OrgInfos.find((o) => o.key === key);
  let required = null;
  if (!target) {
    return null;
  }
  if (target.reqY.includes(orgType)) {
    required = true;
  }
  if (target.reqN.includes(orgType)) {
    required = false;
  }
  if (typeof required !== 'boolean') {
    return null;
  }
  const req = props.required ?? required;
  const prop = {
    required,
    rule: target.maxLen ? getRuleLen(target.maxLen, req) : req ? requiredRule : undefined,
    label: target.label,
  };
  if (props.rule) {
    props.rule.required = prop.required;
  }

  return (
    <div className={required?'req-y':'req-n'}>
      <Field {...prop} {...props}>
        {props.children}
      </Field>
    </div>
  );
}
